import {
  Box,
  Collapse,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdCheckCircle } from "react-icons/md";
import { useOptimizeGames } from "../liveStore";
import { useOptimizeStore } from "../store";
import GameAvatar from "./GameAvatar";

// Partner's titles (iOS and Android separate). Marking one makes every card
// preview + "Active since" line use that game; unmarked = random per card.
const GameStrip: React.FC = () => {
  const markedGameId = useOptimizeStore((s) => s.markedGameId);
  const setMarkedGame = useOptimizeStore((s) => s.setMarkedGame);
  const hintDismissed = useOptimizeStore((s) => s.hintDismissed);
  const games = useOptimizeGames();
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");

  return (
    <Box mb="20px">
      {/* fades out (and stays gone) the first time a title gets marked */}
      <Collapse in={!hintDismissed} animateOpacity unmountOnExit>
        <Text color={subColor} fontSize="xs" mb="8px">
          Mark a title to preview the challenges with that game.
        </Text>
      </Collapse>
      <Flex gap="16px" wrap="wrap">
        {games.map((game) => {
          const marked = markedGameId === game.id;
          return (
            <Flex
              key={game.id}
              direction="column"
              align="center"
              cursor="pointer"
              onClick={() => setMarkedGame(marked ? null : game.id)}
              opacity={markedGameId && !marked ? 0.5 : 1}
              transition="opacity 0.15s ease"
              w="120px"
            >
              <Box
                position="relative"
                // concentric with the avatar: its 14px radius + 2px padding +
                // 3px border, so the ring keeps an even gap all the way round
                borderRadius="19px"
                p="2px"
                border="3px solid"
                borderColor={marked ? "green.400" : "transparent"}
              >
                <GameAvatar game={game} size={96} />
                {marked && (
                  <Icon
                    as={MdCheckCircle}
                    color="green.400"
                    bg="white"
                    borderRadius="full"
                    w="18px"
                    h="18px"
                    position="absolute"
                    top="-6px"
                    right="-6px"
                  />
                )}
              </Box>
              <Text
                color={marked ? textColor : subColor}
                fontWeight={marked ? "700" : "500"}
                fontSize="xs"
                mt="4px"
                textAlign="center"
                noOfLines={1}
              >
                {game.name}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

export default GameStrip;
